import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

interface RejectBatchEnrollmentInvitationParams {
  invitationId: string;
  rejectionReason: string;
}

export const rejectBatchEnrollmentInvitation = createApiThunk<void, RejectBatchEnrollmentInvitationParams>(
  "admin/batchEnrollmentInvitation/reject",
  async ({ invitationId, rejectionReason }, { extra: { adminRepository } }) => {
    await adminRepository!.rejectBatchEnrollmentInvitation(invitationId, rejectionReason);
  },
);

export const resetRejectBatchEnrollmentInvitation = createAction("admin/batchEnrollmentInvitation/resetReject");
